module.exports = __webpack_public_path__ + "img/pos.73849649.png";